
export default require('material-ui-wrapper/lib/jss/')
